<template>
  <div class="SayHelloToUs">
    <section class="my-padding" id="contact">
      <div class="fifth d-flex justify-content-center align-items-center mt-5">
        <div class="rr poppinsLights my-row row justify-content-center">
          <div class="sayHelloText text-center align-self-center pt-4 col-lg-9 col-9">
            <h2>Say Hello To Us!</h2>
            <p class="poppinsLights">
              Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod
              <br>tempor incididunt ut labore. et dolore magna aliqua..
            </p>
          </div>
          <div class="location col-lg-4 col-12 pl-4 pt-3">
            <div class="address">
              <div>
                <i class="fa fa-map-marker" aria-hidden="true"></i>
                <strong>Location:</strong>
              </div>
              <p>Admirala Geprata 14</p>
            </div>
            <div>
              <i class="fa fa-phone" aria-hidden="true"></i>
              <strong>Phone:</strong>
              <p>+1234321321</p>
            </div>
            <div>
              <i class="fa fa-globe" aria-hidden="true"></i>
              <strong>Website:</strong>
              <p>websitename@mail.com</p>
            </div>
          </div>
          <form class="formaR col-lg-6 mt-sm-4 mt-4 mt-lg-0 col-12"  @submit.prevent="sendMsg">
            <input
              v-model="name"
              class="form-control mb-2"
              type="text"
              name="name"
              id
              placeholder="Name:"
            >
            <input
              v-model="email"
              class="form-control mb-2"
              type="email"
              name="email"
              id
              placeholder="Email:"
            >
            <textarea
              v-model="body"
              class="form-control"
              name="message"
              id="textArea"
              cols="30"
              rows="5"
            >Your Message:</textarea>
          
          <div class="row  col-12  ">
            <div class="col mt-2 d-flex justify-content-sm-center">
              <button class="btn btn-lg rounded  my-3 ml-1 p-1 " type="submit">Send Message</button>
              <button class="btn btn-lg rounded  my-3 ml-5 p-1"><router-link to="/Messages">View messages</router-link></button>
            </div>
          </div>
          </form>
        </div>
      </div>
      <div class="maps">
        <iframe
          scrolling="no"
          height="400px"
          width="100%"
          border="0"
          marginwidth="0"
          marginheight="0"
          src="https://www.mapquestapi.com/staticmap/v5/map?key=G3yu0OXYCxy8JaxeGfoMc66GHnAYGXVb&center=BELGRADE,SR&zoom=14&type=map&size=1920,400"
        ></iframe>
      </div>
    </section>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "SayHelloToUs",

  data() {
    return {
      name: "",
      email: "",
      body: ""
    }
  },

  methods: {
    sendMsg() {
      axios
        .post(
          "https://proxy-requests.herokuapp.com/http://comtrade.sytes.net/api/messages",
          {
            name: this.name,
            email: this.email,
            body: this.body,
            
          })
          
         .then (()=>{
          this.$swal({
          position: 'center',
          type: 'success',
          title: 'Message sent',
          showConfirmButton: false,
          timer: 2000
      });
          this.$router.replace(this.$route.query.redirect || "/Messages");
   })
          
     
    }
  }
}
</script>

<style scoped>
@import "../style.css";

.ceo {
  border: 10px solid pink;
}

footer {
  background-color: #13253b;
  color: #fff;
  height: 200px;
}

.fifth {
  background-color: #f7f7f7;
  color: #3b3b3b;
}

button {
  background-color: #1fe7b6;
  border: none;
  color: #fff;
  font-family: poppinsMedium;
  font-size: 16px;
  
}

.location {
  background-color: white;
  color: #3b3b3b;
}

.sayHelloText h2 {
  font-family: "Raleway", sans-serif;
  font-size: 2.42rem;
  line-height: 2.9rem;
  color: #3b3b3b;
  font-weight: 600;
}

.sayHelloText h2::after {
  content: "";
  border-bottom: 0.25rem solid #13253b;
  display: block;
  width: 55px;
  margin: 0 auto;
}

iframe {
  overflow: hidden;
}

.poppinsLights {
  font-size: 0.91rem;
  font-family: "Poppins", sans-serif;
  font-weight: 300;
  line-height: 1.57rem;
  color: #3b3b3b;
}

.my-padding {
  padding-right: 0;
  padding-left: 0;
}

.my-row {
  margin-left: 0;
  margin-right: 0;
}
</style>
